
<template lang="pug">
  .navbar-mobile-link(:class="accordionClass")
    a.navbar-mobile-link__header(:href="link", :class="headerClass")
      span {{ heading }}
      icon(
        width="13px"
        height="13px"
        name="chevron-right"
      )
</template>

<script>
  import Accordion from 'scripts/components/basic/Accordion.vue';
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'NavbarMobileLink',
    extends: Accordion,
    components: { Icon },
    props: {
      link: String
    }
  };
</script>

<style scoped lang="scss">
  .navbar-mobile-link__header {
    padding: $grid-gutter 2 * $grid-gutter;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 900;

    & > span {
      text-transform: uppercase;
      color: $color-indigo;
    }
  }
</style>
